import type { ConfigurationItemsByBlock } from '../../workspace/operationsContext'
import type { IndexedRegisteredTenantCreateOperations } from '../registeredTenantCreateOperations/types'

/**
 * Checks whether a non-annulled tenant registration with the given tenantId
 * already exists in the destination block. Returns true when a conflict exists.
 */
export const detectTenantTransferConflict = ({
  registeredTenantCreateOperations,
  tenantId,
  destinationBlock,
}: {
  registeredTenantCreateOperations: ConfigurationItemsByBlock<IndexedRegisteredTenantCreateOperations>
  tenantId: string
  destinationBlock: string
}): boolean => {
  const destinationBlockTenants =
    registeredTenantCreateOperations.get(destinationBlock)
  if (!destinationBlockTenants) {
    return false
  }

  return Array.from(destinationBlockTenants.values()).some((layerTenants) => {
    const matchingTenantsOnLayer = layerTenants.get(tenantId)

    return (
      matchingTenantsOnLayer &&
      matchingTenantsOnLayer.operations.some(
        ({ annulOperations }) => !annulOperations.length,
      )
    )
  })
}
